function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null,
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M19 18.999H5a1 1 0 01-1-1v-.511a2.489 2.489 0 011.385-2.24l3.69-1.849C7.161 11.563 7.007 8.176 7 8.019v-3.02c.379-2.324 2.95-4 5-4 2.049 0 4.618 1.674 4.991 3.917L17 7.999v.02c-.007.161-.168 3.6-2.061 5.391l3.676 1.838A2.489 2.489 0 0120 17.488v.511a1 1 0 01-1 1zm-7-17a4.3 4.3 0 00-4.007 3.082L8 7.999c0 .018.176 3.744 2.269 5.079a.5.5 0 01-.045.868l-4.392 2.2A1.494 1.494 0 005 17.488v.511h14v-.511a1.494 1.494 0 00-.832-1.346l-4.392-2.2a.5.5 0 01-.032-.876C15.77 11.86 15.989 8.189 16 7.987V4.999a4.312 4.312 0 00-4-3zm4.5 6z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M2.5 18.999H1a1 1 0 01-1-1v-.511a2.489 2.489 0 011.385-2.24l3.69-1.849C3.161 11.563 3.007 8.176 3 8.019v-3.02c.379-2.324 2.95-4 5-4a.5.5 0 110 1 4.3 4.3 0 00-4.007 3.082L4 7.999c0 .018.176 3.744 2.269 5.079a.5.5 0 01-.045.868l-4.392 2.2A1.494 1.494 0 001 17.488v.511h1.5a.5.5 0 010 1z"
}));

var SvgClients2 = function SvgClients2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgClients2, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Clients2.6f840202.svg";
export { ForwardRef as ReactComponent };